module.exports = __webpack_public_path__ + "media/images/vip-table-bookings-cd4458756a34ab8845930bc54028bd95.jpg";